    
    import Dialog from '@mui/material/Dialog';
    import DialogActions from '@mui/material/DialogActions';
    import DialogContent from '@mui/material/DialogContent';
    import DialogContentText from '@mui/material/DialogContentText';
    import DialogTitle from '@mui/material/DialogTitle';
    import React, { useState,useEffect} from 'react';
    import {apiUrl} from '../pages/UrlParam';
     
    import {  useNavigate} from 'react-router-dom';
    import { DataGrid, GridToolbar } from '@mui/x-data-grid';

    export default function ImageView({path, productopen}) {
         
        useEffect(() => {
            //alert(productopen)
            if(productopen) {
               // productclose(true);
                //GetData();
            }
          
        }, [productopen.state.isOpen]);

        const handleClose = () => {
           // productclose(false)
           productopen.setState({isOpen: false});
        }
  
        return( 
            <Dialog
                open={productopen.state.isOpen}
                onClose={handleClose}
                maxWidth="md"
            >
                <form  role="form"> 
                
                <DialogContent>
                    <DialogContentText>
                       <h4>{productopen.state.filename}</h4>
                    </DialogContentText>
                    <div className='row mb-6'>
                        <div className='col-lg-12'>
                            <img src={apiUrl + "/" + path} width={"100%"} height={"100%"}></img>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn' onClick={handleClose} type='button'>Close</button>
                </DialogActions>
                </form>
                </Dialog>
        )
    }
    
    